import { Button, Modal, TextField, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

interface DelistOrRejectModalProps {
  show: boolean;
  submit: () => void;
  title: string;
  close: () => void;
  setValue: (value: string) => void;
}

const DelistingOrRejectModal: React.FC<DelistOrRejectModalProps> = ({
  show,
  submit,
  close,
  setValue,
  title,
}) => {
  return (
    <Modal open={show}>
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: 30,
          width: 500,
          margin: "auto",
          borderRadius: 5,
          marginTop: "15vh",
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography>{title} comment</Typography>
          <Close style={{ cursor: "pointer" }} onClick={close} />
        </div>
        <TextField
          placeholder="Enter comment here..."
          fullWidth
          multiline
          rows={5}
          onChange={(evt) => setValue(evt.target.value)}
        />
        <Button variant="outlined" onClick={submit}>
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default DelistingOrRejectModal;
